module.exports = __webpack_public_path__ + "static/media/man.90a061b6.jpg";